import { Reveal } from "./anim";

const CHAPTERS = [
  { n: "01", title: "Create your account", desc: "Sign up as an artist or a label with your email or Google. No invite required — Noizbloc is open to every serious creator." },
  { n: "02", title: "Upload your master", desc: "Add your audio, artwork and metadata. Choose stores, territories and a release date that works for your rollout." },
  { n: "03", title: "We review & deliver", desc: "Our team quality-checks every release, then delivers it to 150+ platforms with the correct splits and credits." },
  { n: "04", title: "Grow & get paid", desc: "Watch streams climb in real time and collect 100% of your royalties on a clear, predictable schedule." },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 sm:py-32 bg-[#040a1a] border-y border-white/5" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <span className="text-xs tracking-[0.25em] uppercase font-bold text-slate-400">The process</span>
                <h2 className="mt-4 font-display font-medium tracking-tight text-white text-3xl sm:text-4xl md:text-5xl leading-[1.05]">
                  Four chapters from demo to worldwide.
                </h2>
                <p className="mt-6 text-slate-400 leading-relaxed">
                  A deliberate, curated pipeline — no clutter, no gatekeeping fees, just your music moving forward.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-white/10 border-t border-white/10">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.05}>
                  <div className="flex gap-6 md:gap-10 py-10 group">
                    <div className="font-display text-4xl md:text-6xl font-medium text-white/15 group-hover:text-blue-500 transition-colors duration-500">
                      {c.n}
                    </div>
                    <div className="pt-1 md:pt-3">
                      <h3 className="font-display text-2xl md:text-3xl text-white tracking-tight">{c.title}</h3>
                      <p className="mt-3 text-slate-400 leading-relaxed max-w-xl">{c.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
